export const getSafeUrl = (url, dummyImg = "") => {
  if (!url) return dummyImg;

  const baseUrl = process.env.REACT_APP_BASE_URL || "";

  // 1. If it's a full Azure/external URL, route it through the Secure SAS Proxy
  if (url.startsWith("http")) {
    return `${baseUrl}/api/media/redirect?url=${encodeURIComponent(url)}`;
  }

  // 2. Fallback for old local paths
  const cleanUrl = url.replace(/\\/g, "/");

  // Ensure there's exactly one slash between baseUrl and cleanUrl
  const separator = baseUrl.endsWith("/") || cleanUrl.startsWith("/") ? "" : "/";

  return baseUrl + separator + cleanUrl;
};
